import { render, staticRenderFns } from "./RequiresUpgradeModal.vue?vue&type=template&id=b4e508fa"
import script from "./RequiresUpgradeModal.vue?vue&type=script&lang=js"
export * from "./RequiresUpgradeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports